<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-terminated',
    }"
  >
    <h4 class="mt-6 mb-9">
      {{ companyName || 'Your company' }}'s account has been suspended.
    </h4>
    <p class="p3">
      Hi {{ firstName }}, we've detected activity on your account that violates our terms
      of service. If you believe this to be an accident, please email us at
      <a href="mailto:support@datapeople.io?subject=Review%20Suspended%20Account">
        support@datapeople.io
      </a> and we'll be happy to review.
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'TerminatedSuspended',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName', 'companyName']),
  },
  created() {
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-873652164/n88iCLvajNQBEMS_y6AD' });
    }
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Terminated Suspended' });
  },
};
</script>
